import axios from '@/utils/request'

/**
 * 新增标签
 * @param {indexNum}
 * @param {name}
 */
export const addTag = (data) => axios({
  url: '/project/label',
  method: 'post',
  data
})

/**
 * 标签列表
 * @param {pageSize}
 * @param {pageIndex}
 * @param {word}
 */
export const getTagList = (params, options) => axios({
  url: '/project/label',
  params,
  options
})

/**
 * 删除标签
 * @param {uuid}
 */
export const deleteTag = (id) => axios({
  url: `/project/label/${id}`,
  method: 'delete'
})

/**
 * 编辑标签
 * @param {indexNum}
 * @param {name}
 * @param {uuid}
 */
export const updateTag = (data) => axios({
  url: '/project/label',
  method: 'put',
  data
})

// 项目

/**
 * 新增项目
 * @param {coveredArea}
 * @param {detailsAddress}
 * @param {developers}
 * @param {indexNum}
 * @param {introduction}
 * @param {labelUuidList}
 * @param {latitude}
 * @param {linkPhone}
 * @param {longitude}
 * @param {name}
 * @param {picture}
 * @param {pictureJson}
 * @param {pictureList}
 * @param {projectAddress}
 * @param {projectType}
 * @param {publicTransport}
 */
export const addProject = (data) => axios({
  url: '/project',
  method: 'post',
  data
})

/**
 * 项目列表
 * @param {pageSize}
 * @param {pageIndex}
 * @param {word}
 */
export const getProjectList = (params, options) => axios({
  url: '/project',
  options,
  params
})

/**
 * 更改项目是否显示状态
 * @param {uuid}
 */
export const setProjectStatus = (id) => axios({
  url: `/project/status/${id}`,
  method: 'put'
})

/**
 * 删除项目
 * @param {uuid}
 */
export const deleteProject = (id) => axios({
  url: `/project/${id}`,
  method: 'delete'
})

/**
 * 项目详情
 * @param {uuid}
 */
export const getProjectDetail = (id) => axios({
  url: `/project/${id}`
})

/**
 * 编辑项目
  * @param {coveredArea}
 * @param {detailsAddress}
 * @param {developers}
 * @param {indexNum}
 * @param {introduction}
 * @param {labelUuidList}
 * @param {latitude}
 * @param {linkPhone}
 * @param {longitude}
 * @param {name}
 * @param {picture}
 * @param {pictureJson}
 * @param {pictureList}
 * @param {projectAddress}
 * @param {projectType}
 * @param {publicTransport}
 */
export const updateProject = (data) => axios({
  url: '/project',
  data,
  method: 'put'
})

// house

/**
 * 新增房源
 * @param {apartmentIntroduction}
 * @param {coveredArea}
 * @param {indexNum}
 * @param {introduction}
 * @param {leasePrice}
 * @param {linkPhone}
 * @param {name}
 * @param {picture}
 * @param {pictureList}
 * @param {projectUuid}
 * @param {video}
 * @param {windowFaces}
 */
export const addHouse = (data) => axios({
  url: '/project/room',
  method: 'post',
  data
})

/**
 * 所有的项目列表， 下拉选择使用
 */
export const getAllProject = () => axios({
  url: '/project/all'
})

/**
 * 房源列表
 */
export const getHouseList = (params) => axios({
  url: '/project/room',
  params
})

/**
 * 更改房源是否显示状态
 */
export const setHouseTag = (uuid) => axios({
  url: `/project/room/status/${uuid}`,
  method: 'put'
})

/**
 * 删除房源
 */
export const deleteHouse = (uuid) => axios({
  url: `/project/room/${uuid}`,
  method: 'delete'
})

/**
 * 房源详情
 */
export const houseDetail = (uuid) => axios({
  url: `/project/room/${uuid}`,
})

/**
 * 编辑房源
 * @param {apartmentIntroduction}
 * @param {coveredArea}
 * @param {indexNum}
 * @param {introduction}
 * @param {leasePrice}
 * @param {linkPhone}
 * @param {name}
 * @param {picture}
 * @param {pictureList}
 * @param {projectUuid}
 * @param {video}
 * @param {windowFaces}
 */
export const updateHouse = (data) => axios({
  url: '/project/room',
  method: 'put',
  data
})
